var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBenchmarking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 31,
    x: 0.5,
    y: 0.5,
    stroke: "#E1E1E1",
    rx: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#DB536A",
    d: "M23.381 11.528l-3.567 3.567a1.289 1.289 0 0 1-1.243 1.62 1.286 1.286 0 0 1-1.285-1.331l-3.254-2.034a1.28 1.28 0 0 1-.937.107l-3.567 3.567a1.288 1.288 0 0 1-1.242 1.619 1.286 1.286 0 1 1 .333-2.528l3.567-3.568a1.287 1.287 0 0 1 1.243-1.618 1.286 1.286 0 0 1 1.284 1.33l3.255 2.034a1.28 1.28 0 0 1 .936-.107l3.568-3.567A1.287 1.287 0 0 1 23.714 9a1.286 1.286 0 1 1-.333 2.528zM8.286 20.57c.355 0 .643.288.643.643v1.929a.643.643 0 0 1-1.286 0v-1.929c0-.355.288-.643.643-.643zm10.285-1.928c.355 0 .643.288.643.643v3.857a.643.643 0 0 1-1.285 0v-3.857c0-.355.287-.643.642-.643zm5.143-5.143c.355 0 .643.288.643.643v9a.643.643 0 0 1-1.286 0v-9c0-.355.288-.643.643-.643zM13.43 15.429c.355 0 .642.287.642.642v7.072a.643.643 0 0 1-1.285 0V16.07c0-.355.287-.642.643-.642z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBenchmarking);
export default __webpack_public_path__ + "static/media/icon-benchmarking.211b09713fae1112c5596604683afab7.svg";
export { ForwardRef as ReactComponent };